import React, { KeyboardEvent, useState } from 'react';

import './SearchBarre.css';
import cross from '../../../assets/svg/cross.svg';
import search from '../../../assets/svg/search.svg';

interface ISearchBarre {
  defaultValue?: string;
  disabled: boolean;
  placeholder?: string;
  setSearchValue: (value: string) => void;
}

const SearchBarre: React.FC<ISearchBarre> = ({ defaultValue, disabled = false, placeholder, setSearchValue }) => {
  const [value, setValue] = useState<string>('');

  const onKeyUpHandler = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setSearchValue(value);
    }
  };
  const removeSearchHandler = () => {
    setValue('');
    setSearchValue('');
  };
  return (
    <div className={`searchBarre ${disabled && 'searchBarre_disabled'}`}>
      <label htmlFor="searchBarre" className="searchBarre_left-icon">
        <img src={search} alt="Search Icon" />
      </label>
      <input
        id="searchBarre"
        defaultValue={defaultValue}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
        onKeyUp={onKeyUpHandler}
        value={value}
      />
      {value && (
        <div className="searchBarre_right-icon" onClick={removeSearchHandler}>
          <img src={cross} alt="Search Icon" />
        </div>
      )}
    </div>
  );
};

export default SearchBarre;
